import { isNotNullOrUndefined } from '@deltasierra/type-utilities';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';

export type KnobBrand = { _knobBrand: any };

export function combineClasses<T extends string>(
    ...classesToCombine: Array<Partial<ClassNameMap<T>> | undefined>
): Partial<ClassNameMap<T>> {
    return classesToCombine
        .reduce<Array<[string, string]>>(
            (all, cur) => [...all, ...cur === undefined ? [] : Object.entries(cur as Record<string, string>)],
            [],
        )
        .reduce<Partial<ClassNameMap<T>>>(
            (all, [key, classes]) => ({
                ...all,
                [key]: [(all as any)[key], classes].filter(isNotNullOrUndefined).join(' '),
            }),
            {},
        );
}
